<template>
    <div class="top-twenty-businesses" v-if="store !== null">
        <div class="top-twenty-businesses__breadcrumb">
            <a class="top-twenty-businesses__breadcrumb-text" href="/analytics/">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r="3" fill="#252628" />
                </svg>
                <span>Аналитика</span>
            </a>
        </div>
        <h1 class="top-twenty-businesses__title" v-html="reportTitle()"></h1>
        <!-- promo -->
        <div class="top-twenty-businesses__date-container">
            <div class="top-twenty-businesses__tab-wrapper" v-if="!isMonthReport">
                <button class="top-twenty-businesses__tab-btn" @click="activeTab = 'current_month'" :class="{ 'active-tab': activeTab === 'current_month' }">
                    {{ store.report_top_20.month_name.toLowerCase() }} {{ store.report_top_20.year }} г.
                </button>
                <button class="top-twenty-businesses__tab-btn" @click="activeTab = 'current_year'" :class="{ 'active-tab': activeTab === 'current_year' }">
                    {{ store.report_top_20.year }} г.
                </button>
            </div>
            <p class="top-twenty-businesses__date" v-else>Дата публикации: {{ seoData.monthly_report.date }}</p>
            <div class="top-twenty-businesses__share">
                <button-share></button-share>
                <a class="top-twenty-businesses__document-link" :href="seoData.monthly_report.report_file?.src" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3 15.0033C3.55228 15.0033 4 15.451 4 16.0033V21.0033H20V16.0033C20 15.451 20.4477 15.0033 21 15.0033C21.5523 15.0033 22 15.451 22 16.0033V21.2533C22 21.7824 21.7464 22.2437 21.3766 22.5518C21.0121 22.8556 20.5509 23.0033 20.1 23.0033H3.9C3.44908 23.0033 2.98792 22.8556 2.62342 22.5518C2.2536 22.2437 2 21.7824 2 21.2533V16.0033C2 15.451 2.44772 15.0033 3 15.0033Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.0114 16.4033C11.4591 16.4033 11.0114 15.9556 11.0114 15.4033V3.40332C11.0114 2.85104 11.4591 2.40332 12.0114 2.40332C12.5637 2.40332 13.0114 2.85104 13.0114 3.40332V15.4033C13.0114 15.9556 12.5637 16.4033 12.0114 16.4033Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.7124 16.2108C12.322 16.6008 11.6894 16.6008 11.299 16.2108L6.76399 11.6808C6.37325 11.2905 6.3729 10.6573 6.76321 10.2666C7.15352 9.87584 7.78668 9.87549 8.17742 10.2658L12.0057 14.0899L15.834 10.2658C16.2247 9.87549 16.8579 9.87584 17.2482 10.2666C17.6385 10.6573 17.6382 11.2905 17.2474 11.6808L12.7124 16.2108Z"
                            fill="white"
                        />
                    </svg>
                    <span>Скачать весь отчет</span>
                </a>
            </div>
        </div>
        <p class="top-twenty-businesses__date top-twenty-businesses__date-year" v-if="!isMonthReport">Дата публикации: {{ seoData.monthly_report.date }}</p>
        <div class="top-twenty-businesses__line"></div>
        <div class="top-twenty-businesses__block-information">
            <div class="top-twenty-businesses__list-container" v-html="detailText"></div>
            <div class="top-twenty-businesses__block-mortgage">
                <h3 class="top-twenty-businesses__block-mortgage-title">Выдача ипотеки крупнейших банков</h3>
                <div class="top-twenty-businesses__block-mortgage-buttons" v-if="isMonthReport">
                    <button
                        class="top-twenty-businesses__block-mortgage-button"
                        :class="stateActive === 1 ? 'top-twenty-businesses__block-mortgage-button_active' : ''"
                        @click="() => (stateActive = 1)"
                    >
                        {{ seoData.monthly_report.month + ' ' + seoData.monthly_report.year }}
                    </button>
                    <button
                        v-if="store?.widget.period && Object.values(store?.widget.period).length !== 0"
                        class="top-twenty-businesses__block-mortgage-button"
                        :class="stateActive === 2 ? 'top-twenty-businesses__block-mortgage-button_active' : ''"
                        @click="() => (stateActive = 2)"
                    >
                        {{ seoData.monthly_report.year_to_date }}
                    </button>
                </div>
                <div
                    class="top-twenty-businesses__block-mortgage-information"
                    :class="stateActive === 1 ? 'top-twenty-businesses__block-mortgage-information_active' : ''"
                >
                    <div
                        class="top-twenty-businesses__block-mortgage-information-block"
                        :class="store?.widget[monthOrYear].sum_quantity_diff === null ? 'top-twenty-businesses__block-mortgage-information-block_center' : ''"
                    >
                        <p class="top-twenty-businesses__block-mortgage-information-block-text">
                            <span>{{ store?.widget[monthOrYear].sum_quantity }}</span> тыс. шт.
                        </p>
                        <div
                            class="top-twenty-businesses__block-mortgage-information-block-improve"
                            :class="
                                store?.widget[monthOrYear].sum_quantity_diff === null
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_default'
                                    : store?.widget[monthOrYear].sum_quantity_diff > 0
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_up'
                                    : 'top-twenty-businesses__block-mortgage-information-block-improve_down'
                            "
                        >
                            <span>{{ makeNumber(store?.widget[monthOrYear].sum_quantity_diff) }} {{ store?.widget[monthOrYear].sum_quantity_unit }}</span>
                        </div>
                    </div>

                    <div
                        class="top-twenty-businesses__block-mortgage-information-block"
                        :class="store?.widget[monthOrYear].sum_volume_diff === null ? 'top-twenty-businesses__block-mortgage-information-block_center' : ''"
                    >
                        <p class="top-twenty-businesses__block-mortgage-information-block-text">
                            <span>{{ store?.widget[monthOrYear].sum_volume }}</span> млрд ₽
                        </p>
                        <div
                            class="top-twenty-businesses__block-mortgage-information-block-improve"
                            :class="
                                store?.widget[monthOrYear].sum_volume_diff === null
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_default'
                                    : store?.widget[monthOrYear].sum_volume_diff > 0
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_up'
                                    : 'top-twenty-businesses__block-mortgage-information-block-improve_down'
                            "
                        >
                            <span>{{ makeNumber(store?.widget[monthOrYear].sum_volume_diff) }} {{ store?.widget[monthOrYear].sum_volume_unit }}</span>
                        </div>
                    </div>
                </div>
                <div
                    v-if="store?.widget.period"
                    class="top-twenty-businesses__block-mortgage-information"
                    :class="stateActive === 2 ? 'top-twenty-businesses__block-mortgage-information_active' : ''"
                >
                    <div
                        class="top-twenty-businesses__block-mortgage-information-block"
                        :class="store?.widget.period.sum_quantity_diff === null ? 'top-twenty-businesses__block-mortgage-information-block_center' : ''"
                    >
                        <p class="top-twenty-businesses__block-mortgage-information-block-text">
                            <span>{{ store?.widget.period.sum_quantity }}</span> тыс. шт.
                        </p>
                        <div
                            class="top-twenty-businesses__block-mortgage-information-block-improve"
                            :class="
                                store?.widget.period.sum_quantity_diff === null
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_default'
                                    : store?.widget.period.sum_quantity_diff > 0
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_up'
                                    : 'top-twenty-businesses__block-mortgage-information-block-improve_down'
                            "
                        >
                            <span>{{ makeNumber(store?.widget.period.sum_quantity_diff) }} {{ store?.widget.period.sum_quantity_unit }}</span>
                        </div>
                    </div>

                    <div
                        class="top-twenty-businesses__block-mortgage-information-block"
                        :class="store?.widget.period.sum_volume_diff === null ? 'top-twenty-businesses__block-mortgage-information-block_center' : ''"
                    >
                        <p class="top-twenty-businesses__block-mortgage-information-block-text">
                            <span>{{ store?.widget.period.sum_volume }}</span> млрд ₽
                        </p>
                        <div
                            class="top-twenty-businesses__block-mortgage-information-block-improve"
                            :class="
                                store?.widget.period.sum_volume_diff === null
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_default'
                                    : store?.widget.period.sum_volume_diff > 0
                                    ? 'top-twenty-businesses__block-mortgage-information-block-improve_up'
                                    : 'top-twenty-businesses__block-mortgage-information-block-improve_down'
                            "
                        >
                            <span>{{ makeNumber(store?.widget.period.sum_volume_diff) }} {{ store?.widget.period.sum_volume_unit }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Выдача ипотеки в продуктовом разрезе -->
        <div class="top-twenty-businesses__block-graphic">
            <h3 class="top-twenty-businesses__block-graphic-title">Выдача ипотеки в продуктовом разрезе</h3>
            <div class="top-twenty-businesses__block-graphic-container">
                <div class="top-twenty-businesses__block-graphic-scheme">
                    <TopTwentyChart :chartData="chartDataProd" :maxCount="maxCountProduct" v-if="maxCountProduct" />
                    <div class="top-twenty-businesses__block-graphic-table-epilog">
                        <p class="top-twenty-businesses__block-graphic-table-epilog-spring">Источник: ДОМ.РФ, данные банков</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M32 18.84H0.0552979V20.6958H32V18.84Z" fill="#DEDEDE" />
                            <path
                                d="M0.0552979 31.9998H2.02372V29.8628H13.2156V22.5518H0.0552979V31.9998ZM2.02372 24.4076H11.2472V28.0069H2.02372V24.4076Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M15.0734 29.8629H22.4971V32H24.5218V29.8629H31.9456V22.5519H15.0734V29.8629ZM24.5218 24.4078H30.0334V28.007H24.5218V24.4078ZM17.0418 24.4078H22.4971V28.007H17.0418V24.4078Z"
                                fill="#DEDEDE"
                            />
                            <path d="M16.9845 0H9.44821V16.9278H16.9845V0ZM15.016 15.0719H11.4166V1.91211H15.016V15.0719Z" fill="#DEDEDE" />
                            <path
                                d="M20.8648 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9758 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8964 4.94899V16.984H20.8648V5.6801Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
                                fill="#DEDEDE"
                            />
                        </svg>
                    </div>
                </div>
                <div class="top-twenty-businesses__block-graphic-table">
                    <h4 class="top-twenty-businesses__block-graphic-table-title">Данные за {{ period() }}</h4>
                    <template v-if="isDesktop">
                        <div class="top-twenty-businesses__block-graphic-table-head">
                            <p>Сегмент</p>
                            <p>Количество</p>
                            <p>Объем</p>
                        </div>
                        <div class="top-twenty-businesses__block-graphic-table-description">
                            <div class="top-twenty-businesses__block-graphic-table-description-first"></div>
                            <div>
                                <p>тыс. шт.</p>
                                <p>{{ isMonthOrYear() }}</p>
                            </div>
                            <div>
                                <p>млрд ₽</p>
                                <p>{{ isMonthOrYear() }}</p>
                            </div>
                        </div>
                        <div class="top-twenty-businesses__block-graphic-table-items">
                            <div class="top-twenty-businesses__block-graphic-table-item">
                                <div class="top-twenty-businesses__block-graphic-table-item-name">
                                    <span>Всего, в т.ч.</span>
                                </div>
                                <div class="top-twenty-businesses__block-graphic-table-item-score 1">
                                    <p v-if="store.report_product" v-html="monthOrYearQuantity('report_product')"></p>
                                    <p v-if="store.report_product" :class="monthOrYearQuantityDiff('report_product') > 0 ? 'up' : 'down'">
                                        <span v-html="makeNumber(monthOrYearQuantityDiff('report_product'))"></span>
                                    </p>
                                </div>
                                <div class="top-twenty-businesses__block-graphic-table-item-score 2">
                                    <p v-if="store?.report_product" v-html="monthOrYearVolume('report_product')"></p>
                                    <p v-if="store?.report_product" :class="monthOrYearVolumeDiff('report_product') > 0 ? 'up' : 'down'">
                                        <span v-html="makeNumber(monthOrYearVolumeDiff('report_product'))"></span>
                                    </p>
                                </div>
                            </div>
                            <template v-if="store">
                                <template v-for="(item, idx) in monthOrYearMonthItems('report_product')" :key="`prod-table-${idx}`">
                                    <div class="top-twenty-businesses__block-graphic-table-item" v-if="item.show_in_table && !checkAllZeros(item)">
                                        <div class="top-twenty-businesses__block-graphic-table-item-name">
                                            <div class="top-twenty-businesses__block-graphic-table-item-box" :style="`background-color: ${item.color}`"></div>
                                            <span v-html="item.product_type"></span>
                                        </div>
                                        <div class="top-twenty-businesses__block-graphic-table-item-score">
                                            <p v-html="item.quantity"></p>
                                            <p :class="Number(item.quantity_diff) !== 0 ? (item.quantity_diff > 0 ? 'up' : 'down') : 'default'">
                                                <span v-if="Number(item.quantity_diff) !== 0" v-html="makeNumber(item.quantity_diff)"></span>
                                                <span v-else>0%</span>
                                            </p>
                                        </div>
                                        <div class="top-twenty-businesses__block-graphic-table-item-score">
                                            <p v-html="item.volume"></p>
                                            <p :class="Number(item.volume_diff) !== 0 ? (item.volume_diff > 0 ? 'up' : 'down') : 'default'">
                                                <span v-if="Number(item.volume_diff) !== 0" v-html="makeNumber(item.volume_diff)"></span>
                                                <span v-else>0%</span>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-if="!isDesktop && store?.report_product">
                        <TopTwentyBusinessesAccordion
                            :element="{
                                quantity: monthOrYearQuantity('report_product'),
                                quantity_diff: monthOrYearQuantityDiff('report_product'),
                                volume_diff: monthOrYearVolumeDiff('report_product'),
                                volume: monthOrYearVolume('report_product')
                            }"
                            :title="'Всего'"
                            :measureType="measureType"
                        />
                        <template v-for="(item, idx) in monthOrYearMonthItems('report_product')" :key="`prod-support-${idx}`">
                            <TopTwentyBusinessesAccordion
                                v-if="item.show_in_table && !checkAllZeros(item)"
                                :element="item"
                                :title="item?.product_type"
                                :measureType="measureType"
                            />
                        </template>
                    </template>
                    <div class="top-twenty-businesses__block-graphic-table-epilog">
                        <p class="top-twenty-businesses__block-graphic-table-epilog-spring">Источник: ДОМ.РФ, данные банков</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M32 18.84H0.0552979V20.6958H32V18.84Z" fill="#DEDEDE" />
                            <path
                                d="M0.0552979 31.9998H2.02372V29.8628H13.2156V22.5518H0.0552979V31.9998ZM2.02372 24.4076H11.2472V28.0069H2.02372V24.4076Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M15.0734 29.8629H22.4971V32H24.5218V29.8629H31.9456V22.5519H15.0734V29.8629ZM24.5218 24.4078H30.0334V28.007H24.5218V24.4078ZM17.0418 24.4078H22.4971V28.007H17.0418V24.4078Z"
                                fill="#DEDEDE"
                            />
                            <path d="M16.9845 0H9.44821V16.9278H16.9845V0ZM15.016 15.0719H11.4166V1.91211H15.016V15.0719Z" fill="#DEDEDE" />
                            <path
                                d="M20.8648 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9758 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8964 4.94899V16.984H20.8648V5.6801Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
                                fill="#DEDEDE"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <!-- Выдача ипотеки c господдержкой -->
        <div class="top-twenty-businesses__block-graphic">
            <h3 class="top-twenty-businesses__block-graphic-title">Выдача ипотеки c господдержкой</h3>
            <div class="top-twenty-businesses__block-graphic-container">
                <div class="top-twenty-businesses__block-graphic-scheme">
                    <TopTwentyChart :chartData="chartDataGov" :maxCount="maxCountGov" v-if="maxCountGov" />
                    <div class="top-twenty-businesses__block-graphic-table-epilog">
                        <p class="top-twenty-businesses__block-graphic-table-epilog-spring">Источник: ДОМ.РФ, данные банков</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M32 18.84H0.0552979V20.6958H32V18.84Z" fill="#DEDEDE" />
                            <path
                                d="M0.0552979 31.9998H2.02372V29.8628H13.2156V22.5518H0.0552979V31.9998ZM2.02372 24.4076H11.2472V28.0069H2.02372V24.4076Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M15.0734 29.8629H22.4971V32H24.5218V29.8629H31.9456V22.5519H15.0734V29.8629ZM24.5218 24.4078H30.0334V28.007H24.5218V24.4078ZM17.0418 24.4078H22.4971V28.007H17.0418V24.4078Z"
                                fill="#DEDEDE"
                            />
                            <path d="M16.9845 0H9.44821V16.9278H16.9845V0ZM15.016 15.0719H11.4166V1.91211H15.016V15.0719Z" fill="#DEDEDE" />
                            <path
                                d="M20.8648 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9758 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8964 4.94899V16.984H20.8648V5.6801Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
                                fill="#DEDEDE"
                            />
                        </svg>
                    </div>
                </div>
                <div class="top-twenty-businesses__block-graphic-table">
                    <h4 class="top-twenty-businesses__block-graphic-table-title">Данные за {{ period() }}</h4>
                    <template v-if="isDesktop">
                        <div class="top-twenty-businesses__block-graphic-table-head">
                            <p>Сегмент</p>
                            <p>Количество</p>
                            <p>Объем</p>
                        </div>
                        <div class="top-twenty-businesses__block-graphic-table-description">
                            <div class="top-twenty-businesses__block-graphic-table-description-first"></div>
                            <div>
                                <p>тыс. шт.</p>
                                <p>{{ isMonthOrYear() }}</p>
                            </div>

                            <div>
                                <p>млрд ₽</p>
                                <p>{{ isMonthOrYear() }}</p>
                            </div>
                        </div>
                        <div class="top-twenty-businesses__block-graphic-table-items">
                            <div class="top-twenty-businesses__block-graphic-table-item">
                                <div class="top-twenty-businesses__block-graphic-table-item-name">
                                    <span>Всего, в т.ч.</span>
                                </div>
                                <div class="top-twenty-businesses__block-graphic-table-item-score">
                                    <p v-if="store?.report_gov_support" v-html="monthOrYearQuantity('report_gov_support')"></p>
                                    <p v-if="store?.report_gov_support" :class="monthOrYearQuantityDiff('report_gov_support') > 0 ? 'up' : 'down'">
                                        <span v-html="makeNumber(monthOrYearQuantityDiff('report_gov_support'))"></span>
                                    </p>
                                </div>
                                <div class="top-twenty-businesses__block-graphic-table-item-score">
                                    <p v-if="store?.report_gov_support" v-html="monthOrYearVolume('report_gov_support')"></p>
                                    <p v-if="store?.report_gov_support" :class="monthOrYearVolumeDiff('report_gov_support') > 0 ? 'up' : 'down'">
                                        <span v-html="makeNumber(monthOrYearVolumeDiff('report_gov_support'))"></span>
                                    </p>
                                </div>
                            </div>
                            <template v-if="store">
                                <template v-for="(item, index) in monthOrYearMonthItems('report_gov_support')" :key="`gov-support-table-${index}`">
                                    <div class="top-twenty-businesses__block-graphic-table-item" v-if="item.show_in_table && !checkAllZeros(item)">
                                        <div class="top-twenty-businesses__block-graphic-table-item-name">
                                            <div class="top-twenty-businesses__block-graphic-table-item-box" :style="`background-color: ${item.color}`"></div>
                                            <span v-html="item.product_type"></span>
                                        </div>
                                        <div class="top-twenty-businesses__block-graphic-table-item-score">
                                            <p v-html="item.quantity"></p>
                                            <p :class="Number(item.quantity_diff) !== 0 ? (item.quantity_diff > 0 ? 'up' : 'down') : 'default'">
                                                <span v-if="Number(item.quantity_diff) !== 0" v-html="makeNumber(item.quantity_diff)"></span>
                                                <span v-else>0%</span>
                                            </p>
                                        </div>
                                        <div class="top-twenty-businesses__block-graphic-table-item-score">
                                            <p v-html="item.volume"></p>
                                            <p :class="Number(item.volume_diff) !== 0 ? (item.volume_diff > 0 ? 'up' : 'down') : 'default'">
                                                <span v-if="Number(item.volume_diff) !== 0" v-html="makeNumber(item.volume_diff)"></span>
                                                <span v-else>0%</span>
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-if="!isDesktop && store?.report_gov_support">
                        <TopTwentyBusinessesAccordion
                            :element="{
                                quantity: monthOrYearQuantity('report_gov_support'),
                                quantity_diff: monthOrYearQuantityDiff('report_gov_support'),
                                volume_diff: monthOrYearVolumeDiff('report_gov_support'),
                                volume: monthOrYearVolume('report_gov_support')
                            }"
                            :title="'Всего'"
                            :measureType="measureType"
                        />
                        <template v-for="(item, idx) in monthOrYearMonthItems('report_gov_support')" :key="`gov-support-${idx}`">
                            <TopTwentyBusinessesAccordion
                                v-if="item.show_in_table && !checkAllZeros(item)"
                                :element="item"
                                :title="item?.product_type"
                                :measureType="measureType"
                            />
                        </template>
                    </template>

                    <div class="top-twenty-businesses__block-graphic-table-epilog">
                        <p class="top-twenty-businesses__block-graphic-table-epilog-spring">Источник: ДОМ.РФ, данные банков</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M32 18.84H0.0552979V20.6958H32V18.84Z" fill="#DEDEDE" />
                            <path
                                d="M0.0552979 31.9998H2.02372V29.8628H13.2156V22.5518H0.0552979V31.9998ZM2.02372 24.4076H11.2472V28.0069H2.02372V24.4076Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M15.0734 29.8629H22.4971V32H24.5218V29.8629H31.9456V22.5519H15.0734V29.8629ZM24.5218 24.4078H30.0334V28.007H24.5218V24.4078ZM17.0418 24.4078H22.4971V28.007H17.0418V24.4078Z"
                                fill="#DEDEDE"
                            />
                            <path d="M16.9845 0H9.44821V16.9278H16.9845V0ZM15.016 15.0719H11.4166V1.91211H15.016V15.0719Z" fill="#DEDEDE" />
                            <path
                                d="M20.8648 5.6801L24.4643 1.91211V16.984H26.4327V5.6801L29.9758 1.91211V16.984H31.9443V0H29.1885L26.4327 2.92441V0H23.6769L18.8964 4.94899V16.984H20.8648V5.6801Z"
                                fill="#DEDEDE"
                            />
                            <path
                                d="M5.56783 16.984H7.53625V15.1282V0H4.78046L0 4.94899V15.0719V16.9278H1.96842H5.56783V16.984ZM2.02466 5.6801L5.62407 1.91211V15.0719H2.02466V5.6801Z"
                                fill="#DEDEDE"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <!-- Крупнейшие банки по объему выдачи ипотечных кредитов -->
        <div class="top-twenty-businesses__block-table">
            <h3 class="top-twenty-businesses__block-table-title">Крупнейшие банки по объему выдачи ипотечных кредитов в {{ tableTitle() }}</h3>
            <template v-if="isDesktop">
                <div class="top-twenty-businesses__block-table-head">
                    <p style="margin-right: 12px">№</p>
                    <p style="margin-right: 12px">Место</p>
                    <p class="second" style="max-width: 220px">Банк</p>
                    <p class="third" style="max-width: 430px">Объем выданных кредитов</p>
                    <p class="fourth" style="max-width: 430px">Количество выданных кредитов</p>
                </div>
                <div class="top-twenty-businesses__block-table-description">
                    <div style="max-width: 24px; margin-right: 12px"></div>
                    <div style="max-width: 280px"></div>
                    <div style="max-width: 430px">
                        <p>млрд ₽</p>
                        <p>{{ isMonthOrYear() }}</p>
                    </div>

                    <div style="max-width: 430px">
                        <p>тыс. шт.</p>
                        <p>{{ isMonthOrYear() }}</p>
                    </div>
                </div>
                <div class="top-twenty-businesses__block-table-items" v-if="store?.report_top_20">
                    <template v-for="(item, idx) in Object.values(store.report_top_20.items)">
                        <div class="top-twenty-businesses__block-table-item" v-if="item.position !== ''">
                            <div class="top-twenty-businesses__block-table-item-num">
                                <span>{{ item.position }}</span>
                            </div>
                            <div class="top-twenty-businesses__block-table-item-name">
                                <p :class="Boolean(item.position_diff) && item.position_diff !== 0 ? (item.position_diff > 0 ? 'up' : 'down') : 'default'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                        <path
                                            d="M9.29241 10.9706C8.8921 11.4906 8.1079 11.4906 7.70759 10.9706L4.54322 6.85999C4.03703 6.20242 4.50579 5.25 5.33563 5.25L11.6644 5.25C12.4942 5.25 12.963 6.20242 12.4568 6.85999L9.29241 10.9706Z"
                                            fill="#DE4A2A"
                                        />
                                    </svg>
                                    <span v-html="Math.abs(item.position_diff) ? Math.abs(item.position_diff) : ''"></span>
                                </p>
                                <span style="max-width: 200px" v-html="item.bank"></span>
                            </div>
                            <div class="top-twenty-businesses__block-table-item-score">
                                <p v-html="item.volume"></p>
                                <p :class="Number(item.volume_diff) !== 0 ? (item.volume_diff > 0 ? 'up' : 'down') : 'normal'">
                                    <span style="color: #252628" v-if="item.volume_diff === '-'">{{ item.volume_diff }}</span>
                                    <span v-html="Number(item.volume_diff) !== 0 ? makeNumber(item.volume_diff) : 0 + '%'" v-else></span>
                                </p>
                            </div>
                            <div class="top-twenty-businesses__block-table-item-score">
                                <p v-html="item.quantity"></p>
                                <p :class="Number(item.quantity_diff) !== 0 ? (item.quantity_diff > 0 ? 'up' : 'down') : 'normal'">
                                    <span style="color: #252628" v-if="item.quantity_diff === '-'">{{ item.quantity_diff }}</span>
                                    <span v-html="Number(item.quantity_diff) !== 0 ? makeNumber(item.quantity_diff) : 0 + '%'" v-else></span>
                                </p>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="top-twenty-businesses__block-table-items top-twenty-businesses__block-table-items_all">
                    <div class="top-twenty-businesses__block-table-item">
                        <div class="top-twenty-businesses__block-table-item-num">
                            <span></span>
                        </div>
                        <div class="top-twenty-businesses__block-table-item-name">
                            <p></p>
                            <span>Всего</span>
                        </div>
                        <div class="top-twenty-businesses__block-table-item-score">
                            <p v-if="store" v-html="store.report_top_20.sum_volume"></p>
                            <p v-if="store" :class="store.report_top_20.sum_volume_diff ? (store.report_top_20.sum_volume_diff > 0 ? 'up' : 'down') : 'normal'">
                                <span v-html="store.report_top_20.sum_volume_diff ? makeNumber(store.report_top_20.sum_volume_diff) : 0 + '%'"></span>
                            </p>
                        </div>
                        <div class="top-twenty-businesses__block-table-item-score">
                            <p v-if="store" v-html="store.report_top_20.sum_quantity"></p>
                            <p
                                v-if="store"
                                :class="store.report_top_20.sum_quantity_diff ? (store.report_top_20.sum_quantity_diff > 0 ? 'up' : 'down') : 'normal'"
                            >
                                <span v-html="store.report_top_20.sum_quantity_diff ? makeNumber(store.report_top_20.sum_quantity_diff) : 0 + '%'"></span>
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="!isDesktop && store?.report_top_20">
                <template v-for="(item, idx) in Object.values(store?.report_top_20.items)" :key="idx">
                    <TopTwentyBusinessesAccordion
                        :element="item"
                        :id="String(idx + 1)"
                        type="gov"
                        :title="item?.bank"
                        :measureType="measureType"
                        v-if="item.position !== ''"
                    />
                </template>
                <TopTwentyBusinessesAccordion
                    :element="{
                        quantity: store.report_top_20.sum_quantity,
                        volume: store.report_top_20.sum_volume,
                        quantity_diff: store.report_top_20.sum_quantity_diff,
                        volume_diff: store.report_top_20.sum_volume_diff,
                        position_diff: 0
                    }"
                    :id="' '"
                    type="gov"
                    :last="true"
                    title="Всего"
                    :measureType="measureType"
                />
            </template>
            <div class="top-twenty-businesses__block-table-button-container">
                <a class="top-twenty-businesses__block-table-link" :href="seoData.monthly_report.report_file?.src" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3 15.0033C3.55228 15.0033 4 15.451 4 16.0033V21.0033H20V16.0033C20 15.451 20.4477 15.0033 21 15.0033C21.5523 15.0033 22 15.451 22 16.0033V21.2533C22 21.7824 21.7464 22.2437 21.3766 22.5518C21.0121 22.8556 20.5509 23.0033 20.1 23.0033H3.9C3.44908 23.0033 2.98792 22.8556 2.62342 22.5518C2.2536 22.2437 2 21.7824 2 21.2533V16.0033C2 15.451 2.44772 15.0033 3 15.0033Z"
                            fill="#82BF00"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.0114 16.4033C11.4591 16.4033 11.0114 15.9556 11.0114 15.4033V3.40332C11.0114 2.85104 11.4591 2.40332 12.0114 2.40332C12.5637 2.40332 13.0114 2.85104 13.0114 3.40332V15.4033C13.0114 15.9556 12.5637 16.4033 12.0114 16.4033Z"
                            fill="#82BF00"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.7124 16.2108C12.322 16.6008 11.6894 16.6008 11.299 16.2108L6.76399 11.6808C6.37325 11.2905 6.3729 10.6573 6.76321 10.2666C7.15352 9.87584 7.78668 9.87549 8.17742 10.2658L12.0057 14.0899L15.834 10.2658C16.2247 9.87549 16.8579 9.87584 17.2482 10.2666C17.6385 10.6573 17.6382 11.2905 17.2474 11.6808L12.7124 16.2108Z"
                            fill="#82BF00"
                        />
                    </svg>
                    <span>Скачать весь отчет</span>
                </a>
            </div>
        </div>
        <!-- banner -->
        <div class="top-twenty-businesses__contact">
            <img src="/static/dist/v2/img/top20contact.jpg" class="top-twenty-businesses__contact-image" title="контакты" />
            <div class="top-twenty-businesses__contact-block">
                <h3 class="top-twenty-businesses__contact-block-title">Участвуйте в рэнкинге</h3>
                <p class="top-twenty-businesses__contact-block-description">
                    Если вы хотите принять участие в рэнкинге крупнейших ипотечных банков, свяжитесь с нами
                </p>
                <a class="top-twenty-businesses__contact-block-link" href="mailto:research@domrf.ru">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M1 7C1 5.89543 1.89543 5 3 5H21C22.1046 5 23 5.89543 23 7V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V7ZM4.85078 7L11.3753 12.2196C11.7405 12.5118 12.2595 12.5118 12.6247 12.2196L19.1492 7H4.85078ZM21 8.08062L13.8741 13.7814C12.7784 14.6579 11.2216 14.6579 10.1259 13.7814L3 8.08062V18H21V8.08062Z"
                            fill="#82BF00"
                        />
                    </svg>
                    <span> research@domrf.ru </span>
                </a>
            </div>
        </div>
        <!-- archive -->
        <div class="top-twenty-businesses__reports-block" v-if="storeReports">
            <div class="top-twenty-businesses__reports-title-block">
                <h3 class="top-twenty-businesses__reports-title">Отчеты за другие периоды</h3>
                <a class="top-twenty-businesses__reports-link" href="/analytics/archive/?section=838" target="_blank">Архив отчетов</a>
            </div>
            <div class="top-twenty-businesses__reports-container">
                <div class="top-twenty-businesses__reports-card" v-for="(item, idx) in storeReports" :key="`reports-card-${idx}`">
                    <p class="top-twenty-businesses__reports-card-text">Итоги работы крупнейших ипотечных банков в {{ item.month_pp }} {{ item.year }} года</p>
                    <a class="top-twenty-businesses__reports-card-link" :href="item.link" target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.68746 6C5.68746 5.44772 6.13518 5 6.68746 5H17C17.5523 5 18 5.44772 18 6V16.3125C18 16.8648 17.5523 17.3125 17 17.3125C16.4477 17.3125 16 16.8648 16 16.3125V8.41423L6.70711 17.7072C6.31659 18.0978 5.68342 18.0978 5.2929 17.7072C4.90237 17.3167 4.90237 16.6836 5.29289 16.293L14.5858 7H6.68746C6.13518 7 5.68746 6.55228 5.68746 6Z"
                                fill="#82BF00"
                            />
                        </svg>
                        <span>Перейти</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import TopTwentyChart from '../charts/components/TopTwentyChart';
import TopTwentyBusinessesAccordion from './TopTwentyBusinessesAccordion';
import ButtonShare from '@/js/vue-components/ui/ButtonShare';
export default {
    name: 'TopTwentyBusinesses',
    components: { ButtonShare, TopTwentyChart, TopTwentyBusinessesAccordion },
    created() {
        this.setReportType();
    },
    props: ['props', 'report'],
    computed: {
        isDesktop() {
            return document.documentElement.clientWidth >= 768;
        },
        detailText() {
            if (this.isMonthReport) {
                return this.seoData.monthly_report.detail_text;
            } else {
                return this.activeTab === 'current_month' ? this.seoData.monthly_report.month_text : this.seoData.monthly_report.year_text;
            }
        }
    },
    data() {
        return {
            maxCountProduct: null,
            maxCountGov: null,
            stateActive: 1,
            store: null,
            storeReports: {},
            seoData: {},
            preload: true,
            isMonthReport: true,
            monthOrYear: '',
            currentMonth: null,
            activeTab: 'current_year',
            measureType: 'г/г',
            chartDataProd: {
                labels: [],
                datasets: []
            },
            chartDataGov: {
                labels: [],
                datasets: []
            }
        };
    },
    watch: {
        activeTab(newVal, oldVal) {
            if (newVal) {
                this.setReportType();
            }
        }
    },
    methods: {
        setReportType() {
            this.seoData = {};
            this.store = null;
            this.seoData = this.detectReportType(this.report);
            this.getStore(`/api/v2/content/analytics/top20-report/${this.props}/`);
            this.getReports();
        },

        makeNumber(el) {
            return Number(el) < 0 ? el + '%' : '+' + Math.abs(el) + '%';
        },

        async getStore() {
            this.store = this.detectReportType(this.report);
            // FIXME: блок нужно будет удалить после фикса на бэке (вывод ИТОГО так же как и при кол-ве 20 банков в списке) так же сделать правку в самой разметке (без проверки пустого последнего номера)
            const tables = Object.keys(this.store.report_top_20.items);
            if (tables.includes('vsego')) {
                let total = {
                    sum_quantity: this.store.report_top_20.items.vsego.quantity,
                    sum_quantity_diff: this.store.report_top_20.items.vsego.quantity_diff,
                    sum_volume: this.store.report_top_20.items.vsego.volume,
                    sum_volume_diff: this.store.report_top_20.items.vsego.volume_diff
                };
                this.store.report_top_20 = { ...this.store.report_top_20, ...total };
            }
            // end
            const resultProd = await this.createDataGraphic(this.store.report_product);

            this.maxCountProduct = resultProd[2];
            this.chartDataProd.labels = resultProd[1];
            this.chartDataProd.datasets = resultProd[0];

            // Проверка на нулевые значения данных. т.к. если последний набор данных окажется нулевым, верхний title будет привязываться к оси x, т.е. окажется внизу
            this.checkSomeZero(this.chartDataProd.datasets);
            //
            const resultGov = await this.createDataGraphic(this.store.report_gov_support);

            this.maxCountGov = resultGov[2];
            this.chartDataGov.labels = resultGov[1];
            this.chartDataGov.datasets = resultGov[0];
            // Проверка на нулевые значения данных. т.к. если последний набор данных окажется нулевым, верхний title будет привязываться к оси x, т.е. окажется внизу
            this.checkSomeZero(this.chartDataGov.datasets);
            this.preload = true;
        },

        async getReports() {
            const data = await axios
                .get(`/api/v2/content/analytics/top20-report/?per=4&exclude_id=${this.props}`)
                .then(response => {
                    this.storeReports = response.data.data;
                    return response.data.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },

        async createDataGraphic(dataStore) {
            Number.prototype.round = function (precision) {
                let factor = Math.pow(10, precision);
                return Math.round(this * factor) / factor;
            };
            let productLabels = [];
            let productsTopics = [];
            let productsData = [];
            let countArray = [];
            let months = Object.values(dataStore.items || dataStore.months);
            months.forEach(item => {
                this.isMonthReport
                    ? productLabels.push([item.month_name, item.year])
                    : this.measureType === 'г/г'
                    ? productLabels.push([item.year])
                    : productLabels.push([item.month_name, item.year]);
            });
            for (let i = 0; i < Object.values(months[0].items).length; i++) {
                const array = [];
                const topics = [];
                months.forEach((item, index) => {
                    array.push(Object.values(item.items).reverse()[i].quantity);
                    topics.push(
                        Object.values(item.items)
                            .sort((a, b) => a.type - b.type)
                            .reverse()[i]
                    );
                });

                productsTopics.push(topics);
                productsData.push(array);
            }
            months.forEach(item => {
                countArray.push(
                    Object.values(item.items).reduce((a, b) => {
                        return Number(a) + parseInt(b.quantity);
                    }, 0)
                );
            });

            let countMaxStore = months;
            let result = [];
            const maxNumber = this.seoData.monthly_report.value_display_graph;
            productsTopics.forEach((item, index) => {
                const newData = JSON.parse(JSON.stringify(item)).map(elem => {
                    let element = elem;
                    if (this.formatToNumber(element.quantity_percent) < 5 && this.formatToNumber(element.quantity) > 2 && element.quantity_percent > 0) {
                        element.quantity =
                            (this.formatToNumber(element.quantity).round(2) / this.formatToNumber(element.quantity_percent).round(2)) *
                            (this.formatToNumber(element.quantity_percent).round(2) * 4 > 5 ? 5 : this.formatToNumber(element.quantity_percent).round(2) * 4);
                    } else if (this.formatToNumber(element.quantity) > 0 && this.formatToNumber(element.quantity) <= 1) {
                        element.quantity = 1;
                    }
                    return this.formatToNumber(element.quantity).round(2);
                });
                let obj = {
                    label: 'Data1',
                    data: newData.reverse(),
                    stack: 'Stack 0',
                    backgroundColor: item[0].color,
                    borderWidth: {
                        top: 4
                    },
                    topics: item.reverse(),
                    maxNumber: Number(maxNumber),
                    borderColor: 'transparent',
                    borderRadius:
                        index === 0
                            ? {
                                  topLeft: 10,
                                  topRight: 10
                              }
                            : {
                                  topLeft: 10,
                                  topRight: 10,
                                  bottomLeft: 6,
                                  bottomRight: 6
                              },
                    countMax: countMaxStore,
                    borderSkipped: false,
                    datalabels: {
                        labels: {
                            value: {
                                color: '#252628',
                                font: {
                                    size: document.documentElement.clientWidth >= 767 ? 14 : 10,
                                    family: 'Gilroy-Medium, Arial, sans-serif'
                                }
                            }
                        }
                    }
                };
                result.push(obj);
            });
            let maxCountProduct = Math.max.apply(null, countArray);
            return [result, productLabels.reverse(), maxCountProduct];
        },

        detectReportType(report) {
            let parsedReport = JSON.parse(report);
            if ('year' in parsedReport || 'month' in parsedReport) {
                this.isMonthReport = false;
                let monthReport;
                if (this.activeTab === 'current_year') {
                    monthReport = parsedReport.year;
                    this.measureType = 'г/г';
                } else {
                    this.currentMonth = parsedReport?.month?.report_top_20?.month;
                    monthReport = parsedReport.month;
                    this.measureType = this.isNotJanuaryOrFebruary() ? 'м/м' : 'г/г';
                }
                this.monthOrYear = this.activeTab;
                delete parsedReport.month;
                delete parsedReport.year;
                return { ...parsedReport, ...monthReport };
            } else {
                this.currentMonth = parsedReport?.report_top_20?.month;
                this.monthOrYear = 'current_month';
                this.measureType = this.isNotJanuaryOrFebruary() ? 'м/м' : 'г/г';
                return parsedReport;
            }
        },

        reportTitle() {
            if (this.isMonthReport) {
                return this.seoData.monthly_report.title;
            } else {
                if (this.activeTab === 'current_month') {
                    return `Итоги работы крупнейших ипотечных банков в&nbsp;декабре&nbsp;${this.seoData.report_top_20.year}&nbsp;года`;
                } else {
                    return `Итоги работы крупнейших ипотечных банков в&nbsp;${this.seoData.report_top_20.year}&nbsp;году`;
                }
            }
        },

        period() {
            if (this.isMonthReport) {
                return `${this.store.monthly_report.month.toLowerCase()} ${this.store.monthly_report.year} года`;
            } else if (this.activeTab === 'current_month') {
                return `декабрь ${this.store.monthly_report.year} года`;
            } else {
                return `${this.store.monthly_report.year} год`;
            }
        },

        isNotJanuaryOrFebruary() {
            return this.currentMonth !== 1 && this.currentMonth !== 2;
        },

        isMonthOrYear() {
            if ((this.isMonthReport || this.activeTab === 'current_month') && this.isNotJanuaryOrFebruary()) {
                return `м/м`;
            } else {
                return `г/г`;
            }
        },

        tableTitle() {
            if (this.isMonthReport) {
                return `${this.store.monthly_report.month_pp} ${this.store.monthly_report.year} года`;
            }
            if (this.activeTab === 'current_month') {
                return `декабре ${this.store.monthly_report.year} года`;
            } else {
                return `${this.store.monthly_report.year} году`;
            }
        },

        monthOrYearQuantity(reportType) {
            if ('months' in this.store[reportType]) {
                return this.store[reportType].months[this.monthOrYear]?.sum_quantity;
            } else return this.store[reportType].items[this.monthOrYear].sum_quantity;
        },

        monthOrYearQuantityDiff(reportType) {
            if ('months' in this.store[reportType]) {
                return this.store[reportType].months[this.monthOrYear].sum_quantity_diff;
            } else return this.store[reportType].items[this.monthOrYear].sum_quantity_diff;
        },

        monthOrYearVolume(reportType) {
            if ('months' in this.store[reportType]) {
                return this.store[reportType].months[this.monthOrYear].sum_volume;
            } else return this.store[reportType].items[this.monthOrYear].sum_volume;
        },

        monthOrYearVolumeDiff(reportType) {
            if ('months' in this.store[reportType]) {
                return this.store[reportType].months[this.monthOrYear].sum_volume_diff;
            } else return this.store[reportType].items[this.monthOrYear].sum_volume_diff;
        },

        monthOrYearMonthItems(reportType) {
            if ('months' in this.store[reportType]) {
                return this.store[reportType].months[this.monthOrYear].items;
            } else return this.store[reportType].items[this.monthOrYear].items;
        },

        checkAllZeros(item) {
            const arr = [item.quantity, item.quantity_percent, item.volume, item.volume_diff];
            // Проверяем, что массив не пустой
            if (!arr || arr.length === 0) {
                return false;
            }

            // Проходим по каждому элементу массива
            return arr.every(item => {
                // Если элемент это строка, убираем пробелы и заменяем запятую на точку
                if (typeof item === 'string') {
                    item = item.trim().replace(',', '.');
                }

                // Преобразуем элемент в число
                const num = Number(item);

                // Проверяем, является ли элемент числом и равен ли он нулю
                return !isNaN(num) && num === 0;
            });
        },

        checkSomeZero(datasets) {
            datasets.forEach((dataSet, index) => {
                dataSet.data.forEach((item, idx) => {
                    if (item !== item) {
                        datasets[index].data[idx] = 0.1;
                        datasets[index].backgroundColor = 'transparent';
                    }
                });
            });
        },

        formatToNumber(input) {
            let number;
            // Проверяем тип входных данных
            if (typeof input === 'number') {
                number = input;
            } else if (typeof input === 'string') {
                // Заменяем запятую на точку, если она есть
                const normalizedString = input.replace(',', '.');
                number = parseFloat(normalizedString);
            } else {
                return 'Неверный тип входных данных';
            }

            // Проверяем, является ли результат числом
            if (isNaN(number)) {
                return 'Неверный формат числа';
            }

            return number;
        }
    }
};
</script>
